import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import {isNumber} from 'tupy-helperjs'

let realPropVal = parseFloat(document.querySelector('#prop-price')?.value)

if (isNaN(realPropVal) || !isNumber(realPropVal)) {
    realPropVal = 0
    let elPrice = document.querySelector('[data-price]')?.textContent;
    if (elPrice) {
        realPropVal = parseFloat(elPrice.replace(/\./g, '').replace(/€/g, ''))
    }
}

console.debug('realPropVal', realPropVal)

let prop_price = realPropVal*.8;
let rate_start = "4.2";
let startLength = 40;
let ltv = (prop_price / realPropVal)*100;

new Vue({
    el: '#calculator',
    components: {
        'vueSlider': VueSlider,
    },
    data: {
        price: prop_price,
        downPayment: currencyFormat(realPropVal - prop_price),
        tradeIn: '',
        length: startLength,
        rate: rate_start,
        calcPayment: '',
        textPrice: realPropVal,
        loanToValue: ltv.toFixed(0),
    },
    computed: {
        _textPrice: function (e) {
            var textPrice= currencyFormat(this.price);
            return textPrice;
        },
        textPrazo: function (e) {
            var textPrazo= this.length + " Anos";
            $('.get-prazo').text(textPrazo);
            return textPrazo;
        },

        textSpread: function (e) {
            var textSpread= this.rate + "%";
            $('.get-spread').text(textSpread);
            return textSpread;
        },

        _calcPayment: function (e) {
            var p = this.price ;
            var r = this.rate / 1200;
            var n = this.length *12;
            var i = Math.pow((1 + r), n);
            var payment = (p * r * i) / (i - 1) || 0;
            var textPrice= currencyFormat(p);
            $('.get-payment b').text(currencyFormat(payment));
            return currencyFormat(payment);
        },

        _downPayment: function (e){
            var p = this.price;
            if((realPropVal - p)< 0){
                return currencyFormat(0);
            }else{
                $('.get-total-cred').text(currencyFormat(p));
                return currencyFormat(realPropVal - p);
            }
        }
    },
    watch: {

        price: function(val, oldVal) {
            this.calcAsMethod();
        },
        length: function(val, oldVal) {
            this.calcAsMethod();
        },
        rate: function(val, oldVal) {
            if(val >= 0.000){
                this.calcAsMethod();
            }else{
                this.rate= oldVal;
            }
        }
    },
    beforeMount() {
        this.textPrice= currencyFormat(this.price);
        this.calcPayment= this.calcPaymentAsMethod();
    },
    methods: {
        calcAsMethod() {
            var p = this.price ;
            var r = this.rate / 1200;
            var n = this.length *12;

            var i = Math.pow((1 + r), n);
            var payment = (p * r * i) / (i - 1) || 0;
            this.loanToValue = ((p/realPropVal)*100).toFixed(0);

            this.textPrice= currencyFormat(p);
            this.calcPayment = currencyFormat(payment);
            //this.loanToValue = loanAsValue

            if((realPropVal - this.price) > 0){
                this.downPayment = currencyFormat(realPropVal - this.price);
            }else{
                this.downPayment =currencyFormat(0);
            }

            $('.get-total-cred').text(currencyFormat(p));
            $('.get-payment b').text(currencyFormat(payment));
            return currencyFormat(payment);
        },

        calcPaymentAsMethod() {
            var p = this.price ;
            var r = this.rate / 1200;
            var n = this.length *12;
            var i = Math.pow((1 + r), n);
            var payment = (p * r * i) / (i - 1) || 0;
            var textPrice= currencyFormat(p);
            $('.get-payment b').text(currencyFormat(payment));
            return currencyFormat(payment);
        },
    }
});

//https://blog.tompawlak.org/number-currency-formatting-javascript
function currencyFormat(num) {
    return  num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + "€";
}

$(document).ready(function(){
    $('.closee-all').click(function() {
        $('.wrapper-get-credit').toggleClass('open');
    })
})
